import React, {useEffect, useContext} from 'react'
import {Box, Grid, Button, Typography, CircularProgress} from '@material-ui/core/'
import {FaRegImage} from 'react-icons/fa'
import {Draggable} from 'react-drag-and-drop'
import {
  createBarcodeLabel,
  updateBarcodeLabel,
} from '../../graphql/barcode/mutations/barcodeLabelMutation'
import {Mutation} from 'react-apollo'
import {useHistory} from 'react-router-dom'
import {barcodeSheetQuery} from '../../graphql/barcode/queries/barcodeSheetQuery'
import {libraryPageQuery} from '../../graphql/barcode/queries/libraryPageQuery'
import {getResolutionFactore} from '../../utils/barcodeSheet'
import {useTranslation} from 'react-i18next'
import _ from 'lodash'

import {textbox, image} from './constants'
import useStyles from './BarcodeLabelDropBox.styles'
import {BarcodeLabelEditorContext} from '../../context/BarcodeLabelEditor'
import BarcodeLabelWorkSpace from '../BarcodeLabelWorkSpace'
import {ToastMessageContext} from '../../context/ToastMessage'
import BarcodeLabelZoom from './BarcodeLabelZoom'
import {BarcodeLabelRecordContext} from '../../context/BarcodeLabelRecord'
import {BarcodeSheetRecordContext} from '../../context/BarcodeSheetRecord'
import {BarcodeWizardContext} from '../../context/BarcodeWizard'
import {UserContext} from '../../context/UserContext'
import {validateBarcodePermission} from '../../modules/common/utils/permissions'

function BarcodeLabelDropBox(props) {
  const {state, addItem, setZoom} = useContext(BarcodeLabelEditorContext)
  const toast = useContext(ToastMessageContext)
  const classes = useStyles()
  const {t} = useTranslation()
  const history = useHistory()
  const accountID = parseInt(window.localStorage.getItem('account_id'))
  const accessToken = JSON.parse(window.localStorage.getItem('token'))
  const [dropAreaStyle, setDropAreaStyle] = React.useState({
    width: '100%',
    height: '250px',
  })
  const [call, setcall] = React.useState(false)
  const divRef = React.useRef()
  const {setBarcodeLabelRecord} = useContext(BarcodeLabelRecordContext)
  const {setBarcodeSheetRecord} = useContext(BarcodeSheetRecordContext)
  const {setCreatedBarcodeLabel} = useContext(BarcodeWizardContext)
  const currentUser = React.useContext(UserContext)

  function save(barcodeLabelAction, check, updateExisting = false) {
    
    if(updateExisting){
      if(!validateBarcodePermission(currentUser, "can_edit")){
        toast.popMessage("You don't have sufficient permissions to edit any template", 'warning', divRef.current)
        return;
      }     
    }else{
      if(!validateBarcodePermission(currentUser, "can_add")){
        toast.popMessage("You don't have sufficient permissions to create a new template", 'warning', divRef.current)
        return;
      }
    }  

    setcall(check)

    let data = _.cloneDeep(state.labelItems).map(obj => {
      delete obj['focused']
      delete obj['fields']
      delete obj['size']['lock_ratio']
      return obj
    })

    var resolutionFactore = getResolutionFactore(props.sheetValue.unit)
    var mapped = data.map(item => {
      let value = item
      value.size.width = value.size.width / (resolutionFactore * state.zoom)
      value.size.height = value.size.height / (resolutionFactore * state.zoom)
      value.position.top = value.position.top / (resolutionFactore * state.zoom)
      value.position.left = value.position.left / (resolutionFactore * state.zoom)

      if (value.font_size) {
        value.font_size = value.font_size / state.zoom
      }

      if (item.key === 'companylogo') {
        delete value['image']
        delete value['name']
      }

      return {[item.key]: value}
    })

    var elemenstData = Object.assign({}, ...mapped)

    let barcodeSheetId = parseInt(props.sheetValue.id) ? parseInt(props.sheetValue.id) : null
    if (!barcodeSheetId) {
      toast.popMessage(t('barcode.label.drop-box.sheet-info'), 'warning', divRef.current)
    } else if (!props.labelValue.name) {
      toast.popMessage(t('barcode.label.drop-box.label-name'), 'warning', divRef.current)
    } else if (Object.keys(elemenstData).length === 0) {
      toast.popMessage(t('barcode.label.drop-box.data-design'), 'warning', divRef.current)
    } else {
      barcodeLabelAction({
        variables: {
          ...props.labelValue,
          accountId: accountID,
          barcodeSheetId,
          elements: JSON.stringify(elemenstData),
        },
      })
    }
  }

  const handleChangeScaleMultiplier = newScaleMultiplier => {
    setZoom({zoom: newScaleMultiplier})
  }

  useEffect(() => {
    if (
      props.barcodeStartPosition &&
      document.getElementById('button' + props.barcodeStartPosition)
    ) {
      document.getElementById('button' + props.barcodeStartPosition).click()
    }

    if (props.sheetValue) {
      let resolutionFactore = getResolutionFactore(props.sheetValue.unit)
      let width = state.zoom * props.labelValue.width * resolutionFactore
      let height = state.zoom * props.labelValue.height * resolutionFactore
      setDropAreaStyle({
        width: width,
        height: height,
      })
    }
  }, [props.barcodeStartPosition, props.sheetValue, props.labelValue, state.zoom])

  return (
    <div className={classes.width100}>
      <Grid container>
        <Grid item xs={12} className={classes.messageBox}>
          <Typography style={{fontWeight: 'bold'}}>
            {t('barcode.label.drop-box.please-note')}
          </Typography>

          <Typography>{t('barcode.label.drop-box.destroy-fields')}</Typography>
          <Typography>{t('barcode.label.drop-box.combine-fields')}</Typography>
          <Typography>{t('barcode.label.drop-box.combine-barcodes')}</Typography>
          <Typography>{t('barcode.label.drop-box.box-content')}</Typography>
          <Typography>{t('barcode.label.drop-box.spacing-note')}</Typography>
        </Grid>

        <Grid item className={classes.dropArea} xs={12} style={{height: 350}}>
          <BarcodeLabelWorkSpace width={dropAreaStyle.width} height={dropAreaStyle.height} />
        </Grid>
        <Grid item className={classes.dropToolArea}>
          <BarcodeLabelZoom zoom={state.zoom} onChange={handleChangeScaleMultiplier} />
          <div className={classes.buttonContainer}>
            <Draggable
              type="dragitem"
              data={JSON.stringify(textbox)}
              onClick={e => addItem({item: _.cloneDeep(textbox)})}
            >
              <Box className={classes.toolButton}>T</Box>
            </Draggable>

            <Draggable
              type="dragitem"
              data={JSON.stringify(image)}
              onClick={e => addItem({item: _.cloneDeep(image)})}
            >
              <FaRegImage size={38} />
            </Draggable>
          </div>
        </Grid>
        <Grid item xs={12} className={classes.buttonArea}>
          <Button
            className={classes.button}
            m={2}
            onClick={() => history.goBack()}
            component="button"
          >
            {t('barcode.label.drop-box.cancel')}
          </Button>

          {!props.edit && (
            <Mutation
              mutation={createBarcodeLabel}
              refetchQueries={() => [
                {
                  query: barcodeSheetQuery,
                  variables: {
                    accountId: accountID,
                    token: accessToken,
                  },
                },
                {
                  query: libraryPageQuery,
                  variables: {
                    accountId: accountID,
                    token: accessToken,
                    filter: '',
                  },
                },
              ]}
            >
              {(createBarcodeLabel, {data, loading}) => {
                if (data) {
                  if (call) {
                    setcall(false)
                    if (!data.createBarcodeLabel.errors.length) {
                      toast.popMessage('Barcode Label created successfully', 'success')
                      setCreatedBarcodeLabel(true)
                      setBarcodeLabelRecord(data.createBarcodeLabel.barcodeLabels)
                      setBarcodeSheetRecord(props.sheetValue)
                      history.push({
                        pathname: props.pageFrom ? props.pageFrom : 'barcode-wizard',
                      })
                    } else {
                      toast.popMessage(data.createBarcodeLabel.errors, 'warning', divRef.current)
                    }
                  }
                }

                return (
                  <Button
                    className={classes.button}
                    disabled = {!validateBarcodePermission(currentUser, "can_add")}
                    style={{
                      float: 'right',
                      marginRight: '2rem',
                      background: '#0166a6',
                      color: '#fff',
                    }}
                    onClick={e => save(createBarcodeLabel, true)}
                  >
                    {loading ? (
                      <div>
                        {t('barcode.label.drop-box.saving-template')}
                        <CircularProgress size={20} color="secondary" />
                      </div>
                    ) : (
                      t('barcode.label.drop-box.save-template')
                    )}
                  </Button>
                )
              }}
            </Mutation>
          )}

          {props.edit && (
            <Mutation
              mutation={updateBarcodeLabel}
              refetchQueries={() => [
                {
                  query: libraryPageQuery,
                  variables: {
                    accountId: accountID,
                    token: accessToken,
                    filter: '',
                  },
                },
              ]}
            >
              {(updateBarcodeLabel, {data, loading}) => {
                if (data) {
                  if (call) {
                    setcall(false)
                    if (!data.updateBarcodeLabel.errors.length) {
                      toast.popMessage('Barcode Label updated successfully', 'success')
                      setBarcodeLabelRecord(data.updateBarcodeLabel.barcodeLabels)
                      setBarcodeSheetRecord(props.sheetValue)
                      history.push({
                        pathname: '/barcode-library',
                      })
                    } else {
                      toast.popMessage(data.updateBarcodeLabel.errors, 'warning', divRef.current)
                    }
                  }
                }

                return (
                  <Button
                    className={classes.button}
                    disabled = {!validateBarcodePermission(currentUser, "can_add")}
                    style={{
                      float: 'right',
                      marginRight: '2rem',
                      background: '#0166a6',
                      color: '#fff',
                    }}
                    onClick={e => save(updateBarcodeLabel, true, true)}
                  >
                    {loading ? (
                      <div>
                        {t('barcode.label.drop-box.saving-template')}
                        <CircularProgress size={20} color="secondary" />
                      </div>
                    ) : (
                      t('barcode.label.drop-box.save-template')
                    )}
                  </Button>
                )
              }}
            </Mutation>
          )}
          <div ref={divRef} />
        </Grid>
      </Grid>
    </div>
  )
}

export default BarcodeLabelDropBox
